import { render, staticRenderFns } from "./XPagination.vue?vue&type=template&id=7b72c866&scoped=true"
import script from "./XPagination.vue?vue&type=script&lang=js"
export * from "./XPagination.vue?vue&type=script&lang=js"
import style0 from "./XPagination.vue?vue&type=style&index=0&id=7b72c866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b72c866",
  null
  
)

export default component.exports